// extracted by mini-css-extract-plugin
module.exports = {"toggle":"i_Cz","label":"i_C0"};